module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropbox"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentIndex === 1),
      expression: "currentIndex===1"
    }],
    staticClass: "drop-left staff"
  }, [_c('div', {
    staticClass: "side"
  }, [_c('ul', _vm._l((_vm.wordArr), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "item2",
      class: {
        active: _vm.highLight === index
      },
      on: {
        "click": function($event) {
          _vm.selectItem(index)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userSearch),
      expression: "userSearch"
    }],
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入内容"
    },
    domProps: {
      "value": (_vm.userSearch)
    },
    on: {
      "keyup": _vm.searchStaff,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userSearch = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-search"
  })]), _vm._v(" "), _c('div', {
    staticClass: "departmentSearch"
  }, [_c('el-cascader', {
    attrs: {
      "clearable": "",
      "options": _vm.newDepartmentTree,
      "change-on-select": "",
      "filterable": "",
      "placeholder": "请选择筛选部门"
    },
    on: {
      "change": _vm.chooseDepart
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "list-wrapper",
    on: {
      "scroll": _vm.scrollbar
    }
  }, _vm._l((_vm.wordArr), function(item) {
    return _c('dl', {
      staticClass: "staff-list staff-list-hook"
    }, [_c('dt', {
      staticClass: "word"
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), (!_vm.multiple) ? _vm._l((_vm.userArray), function(user) {
      return (user.firstPinyin === item) ? _c('dd', {
        staticClass: "item2",
        on: {
          "click": function($event) {
            _vm.userSelect(user)
          }
        }
      }, [_c('img', {
        staticClass: "avatar",
        attrs: {
          "src": user.avatar
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "text"
      }, [_vm._v(_vm._s(user.name))])]) : _vm._e()
    }) : _vm._l((_vm.userArray), function(user) {
      return (user.firstPinyin === item) ? _c('label', {
        staticClass: "item2",
        attrs: {
          "for": 'id' + user.userId
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (user.selected),
          expression: "user.selected"
        }],
        attrs: {
          "type": "checkbox",
          "id": 'id' + user.userId,
          "hidden": ""
        },
        domProps: {
          "checked": Array.isArray(user.selected) ? _vm._i(user.selected, null) > -1 : (user.selected)
        },
        on: {
          "change": [function($event) {
            var $$a = user.selected,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(user, "selected", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(user, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(user, "selected", $$c)
            }
          }, function($event) {
            _vm.userSelect(user, 'multiple')
          }]
        }
      }), _vm._v(" "), _c('img', {
        staticClass: "avatar",
        attrs: {
          "src": user.avatar
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "text"
      }, [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('span', {
        staticClass: "el-checkbox__input",
        class: {
          'is-checked': user.selected
        }
      }, [_c('span', {
        staticClass: "el-checkbox__inner"
      })])]) : _vm._e()
    })], 2)
  }))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentIndex === 0),
      expression: "currentIndex===0"
    }],
    staticClass: "drop-left department"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "prefix-icon": "el-icon-search",
      "placeholder": "请输入内容"
    },
    on: {
      "focus": function($event) {
        _vm.departSwitch = false
      },
      "blur": _vm.triggerBlur
    },
    model: {
      value: (_vm.departmentSearch),
      callback: function($$v) {
        _vm.departmentSearch = $$v
      },
      expression: "departmentSearch"
    }
  })], 1), _vm._v(" "), (_vm.departSwitch) ? _c('div', {
    staticClass: "list-wrapper tree"
  }, [_c('el-tree', {
    ref: "tree",
    attrs: {
      "data": _vm.departmentTree,
      "props": _vm.defaultProps,
      "render-after-expand": false,
      "check-strictly": !_vm.isCoupling,
      "show-checkbox": _vm.multiple,
      "default-checked-keys": _vm.selectIds,
      "filter-node-method": _vm.showIds,
      "highlight-current": "",
      "node-key": "id",
      "default-expanded-keys": [1]
    },
    on: {
      "node-click": _vm.handleNodeClick,
      "check-change": _vm.departChange
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.departSwitch) ? _c('ul', {
    staticClass: "depart-search"
  }, _vm._l((_vm.matchDepartment), function(item) {
    return _c('li', {
      staticClass: "item2",
      on: {
        "click": function($event) {
          _vm.searchNodeClick(item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  })) : _vm._e()])]), _vm._v(" "), (_vm.tabShow) ? _c('div', {
    staticClass: "tab-menu"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "item2",
    class: {
      active: _vm.currentIndex === 1
    },
    on: {
      "click": function($event) {
        _vm.changeTab(1)
      }
    }
  }, [_vm._v("员工")]), _vm._v(" "), _c('span', {
    staticClass: "item2",
    class: {
      active: _vm.currentIndex === 0
    },
    on: {
      "click": function($event) {
        _vm.changeTab(0)
      }
    }
  }, [_vm._v("部门")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side"
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v("部门选择")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cf50811","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/dropbox.vue
// module id = 1298
// module chunks = 82